const BASE_URL = '/api/community/public'
const RENTAL_URL = '/api/rental/public'

const api = {
  account: {
    auth: `${BASE_URL}/common/auth`,
    login: `${RENTAL_URL}/account/login`,
    wxcode: `${RENTAL_URL}/common/wechatSign`
  },
  user: {
    info: `${BASE_URL}/user/info`
  },
  reserve: {
    home: `${BASE_URL}/reserve/setting/list`,
    product: {
      homeList: `${BASE_URL}/reserve/product/list`,
      detail: `${BASE_URL}/reserve/product/detail`,
      follow: `${BASE_URL}/reserve/follow/credit`
    },
    comment: {
      add: `${BASE_URL}/reserve/comment/add`,
      list: `${BASE_URL}/reserve/comment/list`,
      detail: `${BASE_URL}/reserve/comment/detail`,
      credit: `${BASE_URL}/reserve/comment/credit`
    },
    order: {
      add: `${BASE_URL}/reserve/order/addnew`,
      list: `${BASE_URL}/reserve/order/list`,
      detail: `${BASE_URL}/reserve/order/detail`,
      addbuyerinfo: `${BASE_URL}/reserve/order/addbuyerinfo`,
      cancel: `${BASE_URL}/reserve/order/cancel`,
      del: `${BASE_URL}/reserve/order/del`,
      pay: `${BASE_URL}/reserve/order/pay`
    }
  },
  integral: {
    pay: `${BASE_URL}/energymall/order/pay`
  },
  caoyuan: {
    add: `${BASE_URL}/order/act2106/new`,
    pay: `${BASE_URL}/order/act2106/pay`,
    detail: `${BASE_URL}/order/act2106/orderinfo`
  }
}

export default api
